module.exports = __webpack_public_path__ + "img/overthinking.ce98350c.svg";